import { lazyWebResolvers } from "outlook-resolvers-web";
import { lazyOfflineResolvers } from "outlook-resolvers-offline";
import { lazyPstResolvers } from "outlook-resolvers-pst";
import { lazyUnifiedInboxResolvers } from "outlook-resolvers-uib";
import { lazyMessageFileResolvers } from "outlook-resolvers-file";
import type { ResolverImports } from "owa-apollo-links";
import type { Resolvers } from "owa-graph-schema";
import { isSafeModeSession } from "owa-config/lib/isSafeModeSession";

let offlineEnabledResolvers: ResolverImports;
let nonOfflineEnabledResolvers: ResolverImports;
let pstResolvers: Resolvers;
let unifiedInboxResolvers: Resolvers;
let messageFileResolver: Resolvers;

export async function getResolvers(offlineEnabled = false, pstEnabled = false, unifiedInboxEnabled = false, messageFileEnabled = false): Promise<ResolverImports> {
    let rv: ResolverImports;
    if (!nonOfflineEnabledResolvers) {
        nonOfflineEnabledResolvers = { web: await lazyWebResolvers.import() };
    }
    
    rv = nonOfflineEnabledResolvers;
    
    if (isSafeModeSession()) {
        return rv;
    }
    
    if (offlineEnabled) {
        if (!offlineEnabledResolvers) {
            offlineEnabledResolvers = {
                ...rv,
                offline: await lazyOfflineResolvers.import(),
            };
        }
        
        rv = offlineEnabledResolvers;
    }
    
    if (pstEnabled) {
        if (!pstResolvers) {
            pstResolvers = await lazyPstResolvers.import();
        }
        
        rv = {
            ...rv,
            pst: pstResolvers,
        };
    }
    
    // Unified Inbox is only enabled if offline is enabled
    if (unifiedInboxEnabled && offlineEnabled) {
        if (!unifiedInboxResolvers) {
            unifiedInboxResolvers = await lazyUnifiedInboxResolvers.import();
        }
        
        rv = {
            ...rv,
            unifiedInbox: unifiedInboxResolvers,
        };
    }
    
    if (messageFileEnabled) {
        if (!messageFileResolver) {
            messageFileResolver = await lazyMessageFileResolvers.import();
        }
        
        rv = {
            ...rv,
            messageFile: messageFileResolver,
        };
    }
    
    return rv;
}
